import {inheritSerialization} from 'cerialize';
import {RsvpQuestion} from './rsvp-question';

@inheritSerialization(RsvpQuestion)
export class RsvpOpenQuestion extends RsvpQuestion {
  public static readonly type = 'RsvpOpenQuestion';
  public readonly type = RsvpOpenQuestion.type;
}
